






















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class StudentSchedule extends Vue {
  @Prop() calendars!: any;
  @Prop() articolazione!: string;
  private completeSchedule: any

  constructor(){
      super()
      this.completeSchedule = []
  }

  created(){
    // console.log(this.articolazione)
    // console.log(this.calendars) 
  }

//   created(){
//       this.calendars.forEach((element: any) => {
//           if(element.schedules.length === 0){
//               this.completeSchedule.push({
//                   idArea: element.idArea,
//                   nomeArea: element.nomeArea,
//                   schedules: [{
//                       idAzienda:0,
//                       assegnazioni:[]
//                   }]
//               })
//           }else{
//               this.completeSchedule.push(element)
//           }
//       });
//     //   console.log(this.calendars)

//   }
}
